<template>
  <div class="misc-wrapper">
    <b-link class="brand-logo">
      <vuexy-logo />
      <h2 class="brand-text text-primary ml-1">Syper</h2>
    </b-link>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">Você não possui autorização! 🔐</h2>
        <p class="mb-2">
          Você não tem permissão para acessar esta página. Voltar para o
          início!!
        </p>
        <b-button variant="primary" class="mb-1 btn-sm-block" :to="'/'">
          >Voltar para o início</b-button
        >
        <b-img fluid :src="imgUrl" alt="Not authorized page" />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { BLink, BImg, BButton } from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import store from '@/store/index'

export default {
  components: {
    BLink,
    BImg,
    BButton,
    VuexyLogo
  },
  data() {
    return {
      downImg: require('@/assets/images/pages/not-authorized.svg')
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/not-authorized-dark.svg')
        return this.downImg
      }
      return this.downImg
    }
  },
  mounted() {
    localStorage.clear() // Isso limpa todo o localStorage
    sessionStorage.clear() // Isso limpa todo o sessionStorage
    window.location.reload(true) // Isso força a recarregar a página ignorando o cache
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
